<template>
  <div class="categories" ref="container">
    <div class="categories__inner" :class="{ _test: isTest }">
      <!-- TO SHOW -->
      <router-link-modified v-for="category in categoriesToShow"
                            :key="category.id"
                            ref="categories"
                            :to="{ name: 'vacancies', query: { categories: category.slug } }"
                            class="categories__item  _no-link"
      >
        <span>{{category.title}}</span>
      </router-link-modified>
      <!-- TO HIDE -->
      <template v-if="isShowMore">
        <router-link-modified
          v-for="category in categoriesToHide"
          class="categories__item  _no-link"
          type="button"
          :key="category.id"
          :to="{ name: 'vacancies', query: { categories: category.slug } }"
        >
          <span>{{category.title}}</span>
        </router-link-modified>
      </template>

      <button
        v-if="isTest || categoriesToHide.length && !isShowMore"
        ref="more"
        class="categories__item  _no-link"
        type="button"
        @click.prevent="isShowMore = true"
      >
        <span>{{$tVacancy('More')}} +{{categoriesToHide.length}}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VacancyCardCategories',
    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      isTest: true,
      timer: null,
      isShowMore: false,
      sliceCategoriesIndex: 100
    }),
    computed: {
      categoriesToShow() {
        return ((this.vacancy || {}).categories || []).slice(0, this.sliceCategoriesIndex)
      },
      categoriesToHide() {
        return ((this.vacancy || {}).categories || []).slice(this.sliceCategoriesIndex, 100)
      }
    },
    methods: {
      checkCategoriesToShow() {
        if(this.isShowMore) return
        this.isTest = true
        this.sliceCategoriesIndex = 100

        setTimeout(() => {
          const categories = this.$refs.categories
          const container = this.$refs.container
          const more = this.$refs.more
          // debugger

          if (container.scrollWidth > container.offsetWidth) {
            const containerRight = container.getBoundingClientRect().right
            const moreWidth = more.offsetWidth + 10
            const rightBorder = containerRight - moreWidth

            const index = categories.findIndex((category) => {
              return category.$el.getBoundingClientRect().right > rightBorder
            })

            if (typeof index === 'number') {
              this.sliceCategoriesIndex = index
            }
          }

          this.isTest = false
        }, 50)
      },
      check() {
        clearTimeout(this.timer)
        this.timer = setTimeout(this.checkCategoriesToShow, 200)
      }
    },
    mounted() {
      this.checkCategoriesToShow()
      window.addEventListener('resize', this.check)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.check)
    }
  }
</script>

<style>

</style>
